export default __webpack_public_path__ + "static/media/ic-arrow.573052f4.svg";